var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data.length>0)?_c('div',{staticClass:"row",staticStyle:{"padding-top":"20px"}},[_c('h6',[_vm._v("Your exams")]),_vm._l((_vm.data),function(item){return _c('data-card',{attrs:{"data":item}})})],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }